export default class Controller {

    constructor() {
        this.app = null;
    }

    setApp(app) {
        this.app = app;
    }

    getApp() {
        return this.app;
    }

    onRegistered() {

    }

    registerAction(name, handler) {
        this.app.registerAction(name, handler);
    }

    renderView(view, model) {
        this.app.renderView(view, model);
    }

}